// extracted by mini-css-extract-plugin
export default {"TotalPrice":"KeGTDl4TWp2BGCX53wR7","TotalPrice__header":"jW24ELm7A__08jssuiCg","TotalPrice__text":"e2IWzc1gFxUtVi5YtGgU","TotalPrice__info":"ysCZ68ah60zxxyun0dVx"};